import { render } from "./BlockPreloader.vue?vue&type=template&id=62d41e2a&scoped=true&ts=true&lang=pug"
import script from "./BlockPreloader.vue?vue&type=script&lang=ts"
export * from "./BlockPreloader.vue?vue&type=script&lang=ts"

import "./BlockPreloader.vue?vue&type=style&index=0&id=62d41e2a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d41e2a"]])

export default __exports__